import type {
  CandidatePrivateDataEditInitialValues,
  CandidatePrivateDetails,
} from '../types';

export const getCandidatePrivateDataEditInitialValues = (
  data: CandidatePrivateDetails
): CandidatePrivateDataEditInitialValues => {
  const allCities = data.allCities || data.cityIds.length === 0;

  return {
    lastName: data.lastName,
    firstName: data.firstName,
    phone: data.phone,
    preferredCommunicationLanguage: data.preferredCommunicationLanguage,
    allCities,
    cityIds: allCities ? [] : data.cityIds,
    educationLevelId: data.educationLevel?.id.toString() ?? null,
    professionName: data.educationLevel?.professionName ?? '',
    generalInfo: data.generalInfo ?? '',
  };
};
